// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__BQLjr","ProducersDetailLinkContainer":"styles_ProducersDetailLinkContainer__YXiK+"};